export default __webpack_public_path__ + "static/media/footerWaves.4b0f3dbd.webp";